<template>
  <CSidebar fixed :class="{ 'sidebar-toggle': isHamburger }">
    <CSidebarBrand class="d-md-down-none">
      <span>Docsmart Admin </span>
      <!-- <CIcon 
        class="c-sidebar-brand-full" 
        name="logo" 
        size="custom-size" 
        :height="35" 
        viewBox="0 0 556 134"
      />
      <CIcon 
        class="c-sidebar-brand-minimized" 
        name="logo" 
        size="custom-size" 
        :height="35" 
        viewBox="0 0 110 134"
      />-->
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="updated_nav" />
    <!-- <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    /> -->
  </CSidebar>
</template>

<script>
import { mapGetters } from "vuex";
import navInfo from "@/methods/navLinks.vue";
// import { bus } from "@/main.js";
export default {
  mixins: [navInfo],
  name: "TheSidebar",
  data() {
    return {
      updated_nav: [],
      totalNavLinks: [],
      activeTabLink: ["Diagnostics", "Pharmacy", "Bloodbank", "Ambulance"],
    };
  },
  created() {
    this.getUpdatedNav();
  },
  watch: {
    permissions: function (permissions) {
      if (permissions) {
        this.getUpdatedNav();
      }
    },
  },
  methods: {
    getUpdatedNav() {
      this.updated_nav = JSON.parse(localStorage.getItem("updatedNav"));
    },
  },
  computed: {
    ...mapGetters({
      permissions: "getPermissions",
      nav: "getNav",
    }),
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
    isHamburger() {
      return (
        this.$store &&
        this.$store.state &&
        this.$store.state.user &&
        this.$store.state.user.isHamburger
      );
    },
  },
};
</script>

<style lang="scss" >
// .class-1 {
//   background-color: red !important;
// }
</style>
